import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41eb1c27")

_pushScopeId("data-v-41eb1c27")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = { class: "subdate" }
const _hoisted_3 = {
  key: 0,
  class: "daily-view"
}
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = { class: "table is-bordered is-fullwidth is-narrow is-hoverable" }
const _hoisted_6 = /*#__PURE__*/_createVNode("th", null, "User", -1)
const _hoisted_7 = { class: "hours" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "legend" }, [
  /*#__PURE__*/_createVNode("span", { class: "legend__item legend__item--remote" }, "Remote"),
  /*#__PURE__*/_createVNode("span", { class: "legend__item legend__item--office" }, "Office")
], -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-spin fa-sync-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Loading...")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_time_switcher = _resolveComponent("time-switcher")
  const _component_user_row = _resolveComponent("user-row")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_time_switcher, {
      onPrev: _ctx.previousDay,
      onNext: _ctx.nextDay
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.format(_ctx.currentDate, 'dd.MM.yy')) + " ", 1),
        _hoisted_1,
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.format(_ctx.currentDate, 'EEEE')), 1)
      ]),
      _: 1
    }, 8, ["onPrev", "onNext"]),
    (!_ctx.isLoading && _ctx.hours.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("table", _hoisted_5, [
              _createVNode("tr", null, [
                _hoisted_6,
                _createVNode("th", {
                  colspan: _ctx.hours.length,
                  class: "timeline-row"
                }, [
                  _createVNode("div", _hoisted_7, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                      return (_openBlock(), _createBlock("div", {
                        key: hour,
                        class: "hour"
                      }, _toDisplayString(hour) + ":00 ", 1))
                    }), 128))
                  ])
                ], 8, ["colspan"])
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createBlock(_component_user_row, {
                  key: user.id,
                  hours: _ctx.hours,
                  user: user
                }, null, 8, ["hours", "user"]))
              }), 128))
            ])
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _hoisted_10
        ]))
      : _createCommentVNode("", true)
  ]))
})